var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagCaymanIslands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0107C32 24.8472 24.8365 32.0107 16 32.0107C7.1635 32.0107 0 24.8472 0 16.0107C0 16.0146 16 0.0124922 16 0.0107422C24.8365 0.0107422 32 7.17424 32 16.0107Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9572 16.0108H16C16 15.9965 16 15.9825 16 15.968C15.9858 15.9823 15.9715 15.9966 15.9572 16.0108Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.35855C16 5.54324 16 3.69855 16 0.0107422H15.9973C7.16194 0.0122422 0 7.17505 0 16.0107H8.34781V11.3101L13.0485 16.0107H15.9572C15.9715 15.9965 15.9858 15.9822 16.0001 15.9679C16.0001 14.89 16.0001 13.9282 16.0001 13.0594L11.2992 8.35855H16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9565 11.837C24.4933 11.837 25.7391 10.5912 25.7391 9.05435C25.7391 7.51755 24.4933 6.27173 22.9565 6.27173C21.4197 6.27173 20.1739 7.51755 20.1739 9.05435C20.1739 10.5912 21.4197 11.837 22.9565 11.837Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09469 2.09766C5.59225 3.52259 3.51181 5.60297 2.08694 8.10541V16.0107H6.26087V6.27172V6.27159H16C16 4.95516 16 3.70103 16 2.09766H8.09469Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14.0432L10.3153 8.35864H8.34781V8.35877L15.9999 16.0108H16C16 16.0108 16 14.6541 16 14.0432Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0869 8.35864H27.8261V12.5326H18.0869V8.35864Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0869 18.7935V21.5761H19.5509C20.4288 22.4363 21.6303 22.9674 22.9565 22.9674C24.2827 22.9674 25.4843 22.4363 26.3621 21.5761H26.4347H27.8261V18.7935H18.0869Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0869 11.8369V16.0109C18.0869 19.7383 22.9565 20.8804 22.9565 20.8804C22.9565 20.8804 27.8261 19.7383 27.8261 16.0109V11.8369H18.0869Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9562 14.0664C21.7389 14.0664 21.7389 15.1795 20.5216 15.1795C19.3043 15.1795 19.3043 14.0664 18.087 14.0664V16.0142C19.3043 16.0142 19.3043 17.1273 20.5216 17.1273C21.7389 17.1273 21.7389 16.0142 22.9562 16.0142C24.1737 16.0142 24.1737 17.1273 25.3912 17.1273C26.6087 17.1273 26.6086 16.0142 27.8261 16.0142V14.0664C26.6087 14.0664 26.6087 15.1795 25.3912 15.1795C24.1737 15.1795 24.1737 14.0664 22.9562 14.0664Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9562 10.1672C21.7389 10.1672 21.7389 11.2803 20.5216 11.2803C19.3043 11.2803 19.3043 10.1672 18.087 10.1672V12.115C19.3043 12.115 19.3043 13.2281 20.5216 13.2281C21.7389 13.2281 21.7389 12.115 22.9562 12.115C24.1737 12.115 24.1737 13.2281 25.3912 13.2281C26.6087 13.2281 26.6086 12.115 27.8261 12.115V10.1672C26.6087 10.1672 26.6087 11.2803 25.3912 11.2803C24.1737 11.2803 24.1737 10.1672 22.9562 10.1672Z",
    fill: "#F3F3F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCaymanIslands);
export default __webpack_public_path__ + "static/media/flag_cayman_islands.01a7bcb7acee8fe87b33627d3d12265e.svg";
export { ForwardRef as ReactComponent };